module.exports = __webpack_public_path__ + "static/board-21-5e6aef0c78f5c8f384bad7008de7e68a.jpg";